<template>
  <a-card :bordered="false">
    <a-row :gutter="24" style="margin-bottom: 2vh;">
      <a-col :md="12" :sm="24" style="margin-bottom: 2vh;">
        <a-input-search v-model="query.name" placeholder="输入企业名称进行搜索" enterButton @search="handleSearch"/>
      </a-col>
      <a-col :md="8" :sm="24">
        <a-button type="primary" @click="handleCreate">新建企业</a-button>
      </a-col>
    </a-row>

    <a-table
      :rowSelection="rowSelection"
      :columns="columns"
      :rowKey="record => record.id"
      :dataSource="page.content"
      :pagination="pagination"
      :loading="tableLoading"
      @change="handleTableChange">
      <template slot="rank" slot-scope="text">
        <a-tag color="blue">{{ rankRender(text) }}</a-tag>
      </template>
      <template slot="licenses" slot-scope="text, item">
        <div>{{ text }} / {{ item.maxDeviceLimit }}</div>
      </template>
      <span slot="action" slot-scope="text, record">
        <a href="javascript:;" @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-popconfirm placement="topLeft" @confirm="handleDelete(record)" okText="确定" cancelText="取消">
          <template slot="title">
            <p style="font-size:1.7vh;color:red">注意: 操作不可撤销</p>
            <p>确定要删除该企业吗?</p>
          </template>
          <a href="javascript:;">删除</a>
        </a-popconfirm>
      </span>
    </a-table>

    <a-modal
      :visible="visible"
      :maskClosable="false"
      :confirmLoading="loading"
      :okButtonProps="{ props: {disabled: false} }"
      :title="title"
      @ok="handleOk"
      @cancel="visible = false">
      <a-spin :spinning="spinning">
        <a-form :form="form">
          <a-form-item label="名称" :labelCol="{ span: 5 }" :wrapperCol="{ span: 17 }">
            <a-input
              placeholder="输入企业名称"
              v-decorator="[ 'name', {
                rules: [{ required: true, message: '企业名称不能为空' },
                        { pattern: /[\u4E00-\u9FA5\uF900-\uFA2D]{2,40}$/, message: '名称限制2-40个中文字符' }],
                validateTrigger: 'blur'
              }]"
            />
          </a-form-item>
          <a-form-item label="等级" :labelCol="{span: 5}" :wrapperCol="{span: 17}">
            <a-select
              placeholder="选择企业等级"
              class="hundred"
              v-decorator="[ 'rank', { rules: [{ required: true, message: '至少选择一个等级' }] } ]"
            >
              <a-select-option v-for="item in levels" :key="item.value">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="授权激活" :labelCol="{ span: 5 }" :wrapperCol="{ span: 17 }">
            <a-input-number
              :min="1"
              :max="99999"
              v-decorator="[ 'maxDeviceLimit', {
                rules: [{ required: true, message: '授权激活数量不能为空' }],
                validateTrigger: 'blur',
                initialValue: 100
              }]"/>&nbsp;&nbsp;台
          </a-form-item>
          <a-form-item label="地区" :labelCol="{ span: 5 }" :wrapperCol="{ span: 17 }">
            <a-cascader
              :options="options"
              placeholder="选择地区"
              @change="onChange"
              v-decorator="[ 'areaCode', { rules: [{ required: true, message: '必须选择一个地区' }] } ]"
            />
          </a-form-item>
          <a-form-item label="地址" :labelCol="{ span: 5 }" :wrapperCol="{ span: 17 }">
            <a-input
              placeholder="输入地址"
              v-decorator="[ 'address', { rules: [{ max: 50, message: '地址最长不超过50个字符' }] } ]"
            />
          </a-form-item>
          <a-form-item label="显示顺序" :labelCol="{ span: 5 }" :wrapperCol="{ span: 17 }">
            <a-input-number
              :min="1"
              :max="999"
              v-decorator="[ 'sort', {
                rules: [{ required: true, message: '显示顺序限制1-999之间' }],
                validateTrigger: 'blur',
                initialValue: 50
              }]"/>
          </a-form-item>
          <a-form-item label="服务到期" :labelCol="{ span: 5 }" :wrapperCol="{ span: 17 }">
            <a-date-picker
              placeholder="2099-01-01"
              format="YYYY-MM-DD"
              :disabledDate="disabledDate"
              v-decorator="[ 'gmtExpire', { initialValue: date, rules: [{ required: true, message: '服务到期时间不能为空' }] } ]"
            />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </a-card>
</template>

<script>
import moment from 'moment'
import areaJson from '@/assets/area.json'
import { convertToPagination } from '@/utils/util'
import { getCorp, pageCorp, createCorp, updateCorp, deleteCorp } from '@/api/corp'

const columns = [
  {
    title: '名称',
    dataIndex: 'name'
  },
  {
    title: '等级',
    dataIndex: 'rank',
    scopedSlots: { customRender: 'rank' }
  },
  {
    title: '地区',
    dataIndex: 'areaName'
  },
  {
    title: '授权 (可用/总数)',
    dataIndex: 'availableLicenses',
    scopedSlots: { customRender: 'licenses' }
  },
  // {
  //   title: '地址',
  //   dataIndex: 'address'
  // },
  {
    title: '服务到期时间',
    dataIndex: 'gmtExpire'
  },
  {
    title: '操作',
    dataIndex: 'action',
    // width: '150px',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  data () {
    return {
      columns,
      form: this.$form.createForm(this),
      visible: false,
      tableLoading: false,
      loading: false,
      spinning: false,
      title: '新建企业',
      date: moment('2099-01-01', 'YYYY-MM-DD'),
      options: areaJson,
      query: {
        name: '',
        prop: '',
        direction: '',
        pageSize: 10,
        pageNumber: 0
      },
      page: {
        content: [],
        empty: false,
        first: true,
        last: true,
        number: 1,
        numberOfElements: 1,
        size: 1,
        sort: {},
        totalElements: 1,
        totalPages: 1
      },
      pagination: {
        current: 1,
        defaultPageSize: 10,
        pageSize: 10,
        total: 0
      },
      selectedRowKeys: [],
      selectedRows: [],
      editingId: '',
      levels: [{
        value: 0,
        name: '普通会员'
      }, {
        value: 1,
        name: 'VIP 1'
      }, {
        value: 2,
        name: 'VIP 2'
      }, {
        value: 3,
        name: 'VIP 3'
      }, {
        value: 4,
        name: 'VIP 4'
      }, {
        value: 5,
        name: 'VIP 5'
      }]
    }
  },

  computed: {
    rowSelection () {
      const ctx = this
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
          ctx.unitIds = selectedRowKeys
          console.log(ctx.unitIds)
        }
      }
    }
  },

  watch: {
    'page.content' (val) {
      if (val && val.length > 0) {
        val.forEach(v => {
          v.areaCode = v.areaCode.sort((a, b) => a.length - b.length)
          v.areaName = ''
          this.getAreaNames(v.areaCode).forEach(a => {
            v.areaName = v.areaName + a + ' '
          })
        })
      }
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {
    fetchData () {
      this.tableLoading = true
      pageCorp(this.query).then(response => {
        this.page = response.data
        this.pagination = convertToPagination(this.page, this.pagination)
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.tableLoading = false
      })
    },

    handleSearch () {
      this.query.pageNumber = 0
      this.fetchData()
    },

    rankRender (rank) {
      const arr = this.levels.filter(level => level.value === rank)
      if (arr.length > 0) {
        return arr[0].name
      }
      return 'N/A'
    },

    getAreaNames (areaCode) {
      return this.doMap(this.options, areaCode, 0, [])
    },

    doMap (srcArr, values, count, result) {
      if (srcArr && srcArr.length > 0) {
        for (let i = 0; i < srcArr.length; i++) {
          if (srcArr[i].value === values[count]) {
            result.push(srcArr[i].label)
            this.doMap(srcArr[i].children, values, ++count, result)
            break
          }
        }
      }
      return result
    },

    handleCreate () {
      this.title = '新建企业'
      this.editingId = ''
      this.visible = true
      setTimeout(() => {
        this.form.resetFields()
      }, 0)
    },

    handleEdit (record) {
      this.title = '编辑企业'
      this.editingId = record.id
      this.visible = true
      this.$nextTick(() =>
        this.form.setFieldsValue({
          'name': record.name,
          'rank': record.rank,
          'maxDeviceLimit': record.maxDeviceLimit,
          'areaCode': record.areaCode,
          'address': record.address,
          'sort': record.sort,
          'gmtExpire': moment(record.gmtExpire, 'YYYY-MM-DD')
        })
      )
    },

    handleDelete (record) {
      deleteCorp(record.id).then(response => {
        this.$message.success(response.msg)
        this.fetchData()
      }).catch(err => {
        console.log(err)
      })
    },

    handleOk () {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          if (values.gmtExpire) {
            values.gmtExpire = values.gmtExpire.format('YYYY-MM-DD hh:mm:ss')
          }
          if (!this.editingId) {
            createCorp(values).then(response => {
              this.$message.success(response.msg)
              this.visible = false
              this.fetchData()
            }).catch(err => {
              console.log(err)
            }).finally(() => {
              this.loading = false
            })
          } else {
            updateCorp(this.editingId, values).then(response => {
              this.$message.success(response.msg)
              this.visible = false
              this.fetchData()
            }).catch(err => {
              console.log(err)
            }).finally(() => {
              this.loading = false
            })
          }
        } else {
          console.log(err)
          this.loading = false
        }
      })
    },

    onChange (value, selectedOptions) {
      console.log(value, selectedOptions)
    },

    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    handleTableChange (pagination, filters, sorter) {
      this.query.pageNumber = pagination.current - 1
      this.query.pageSize = pagination.pageSize
      this.fetchData()
    },

    disabledDate (current) {
      // Can not select days before today and today
      return current && current < moment().endOf('day')
    }
  }
}
</script>

<style lang="less" scoped>
  .forty {
    width: 40%;
  }
  .sixty {
    width: 60%;
  }
  .hundred {
    width: 100%;
  }
</style>
